/* ManageDeviceViewRenderer.js */

"use strict";
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;

class ManageDeviceViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("seeded-device-view-gl");
        this._rootElem.component = this._model;
        this._targets = {};

        this._availGridContainer = document.createElement("avail-grid-container");
        this._availFilterComponent = document.createElement("game-editor-header-gl");
        this._availFilterComponent.classList.add("ge-header");

        this._prevSelectedIDs = [];
        this._selectFilterHeader = this._generateElement(
            "span",
            "ge-header-text",
            "Selected Devices"
        );

        this._registerListeners();
        this._registerViewAction();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    /**
     * Generate
     */
    _generateElement(name, className, text) {
        const el = document.createElement(name);
        el.classList.add(className);
        el.innerText = text;
        return el;
    }

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "PagingFeedChange",
            (this._onPagingFeedChange = this._onPagingFeedChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("PagingFeedChange", this._onPagingFeedChange);
    }

    _registerAvailGridListeners() {
        this._availableTargetsGrid.on(
            "UserSelectedRows",
            (this._onAvailGridUserSelectedRows = this._onAvailGridUserSelectedRows.bind(this))
        );
        this._availableTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onAvailGridUserRowDoubleClicked =
                this._onAvailGridUserRowDoubleClicked.bind(this))
        );
        this._availableTargetsGrid.on(
            "BasicSearchFilterChangeData",
            (this._onUserSelectFilter = this._onUserSelectFilter.bind(this))
        );
    }

    _unregisterAvailGridListeners() {
        this._availableTargetsGrid.removeListener(
            "UserSelectedRows",
            this._onAvailGridUserSelectedRows
        );
        this._availableTargetsGrid.removeListener(
            "UserRowDoubleClicked",
            this._onAvailGridUserRowDoubleClicked
        );
        this._availableTargetsGrid.removeListener(
            "AdvancedSearchFilterChangeData",
            this._onUserSelectFilter
        );
    }

    _registerViewAction() {
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "OK",
            name: "SavePlanDevice",
            handler: (this._onPlanDeviceSave = this._onPlanDeviceSave.bind(this)),
        });
        // this.model.gameEditor.addViewAction({
        //     type: "normal",
        //     displayName: "Cancel",
        //     name: "CancelPlanDevice",
        //     handler: (this._onPlanDeviceCancel = this._onPlanDeviceCancel.bind(this))
        // });
    }
    _hideViewAction() {
        this.model.gameEditor.hideViewAction("SavePlanDevice");
        // this.model.gameEditor.hideViewAction("CancelPlanDevice");
    }
    _disableViewActions() {
        this.model.gameEditor.disableViewAction("SavePlanDevice");
        // this.model.gameEditor.disableViewAction("CancelPlanDevice");
    }

    _enableViewActions() {
        this.model.gameEditor.enableViewAction("SavePlanDevice");
        // this.model.gameEditor.enableViewAction("CancelPlanDevice");
    }
    _removeViewActions() {
        this.model.gameEditor.removeViewAction("SavePlanDevice");
        // this.model.gameEditor.removeViewAction("CancelPlanDevice");
    }
    _toggleAction(isDirty) {
        if (isDirty || this._model._planDetails.isCompleted) {
            this._disableViewActions();
        } else {
            this._enableViewActions();
        }
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._availGridContainer);
        }
        return Promise.resolve()
            .then(() => {
                return this._model.whenModelIsReady();
            })
            .then(() => {
                this._renderAvailGrid();
            })
            .then(() => {
                // let ids = this._model.selectedIDs;
                // _.delay(this._initTargets.bind(this), 500, ids);
                this._toggleAction(this._model.isDirty);
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._availableTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderAvailGrid() {
        this._availGridContainer.innerHTML = "";
        this._availableTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.availColumnConfig,
            pagingFeed: this._model.availableTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_available`,
            showLinesNumber: true,
            useUserDataStorage: false,
            filterComponent: this._availFilterComponent,
        });
        this._availGridContainer.appendChild(this._availFilterComponent);
        this._availGridContainer.appendChild(this._availableTargetsGrid.renderer.rootElement);
        this._registerAvailGridListeners();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onPagingFeedChange() {
        this._renderAvailGrid();
    }

    _onAvailGridUserSelectedRows() {
        // this._addButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onAvailGridUserRowDoubleClicked() {
        // if (!this._checkDisabled(false)) {
        //     this._addToTargets([e.selectedRow]);
        // }
    }
    _onUserSelectFilter() {
        let filterQuery = this._availableTargetsGrid._filterQuery;
        this._model._availableDevicesPagingFeed._deviceAvilaFeedReestablish(filterQuery);
    }

    _onSelGridUserSelectedRows() {
        // this._removeButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onSelGridUserRowDoubleClicked() {
        // if (!this._checkDisabled(false)) {
        //     this._removeFromTargets([e.selectedRow]);
        // }
    }

    _onShutdown() {
        let shutdowns = [this._availableTargetsGrid.shutdown()];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                this._unregisterAvailGridListeners();
                this._removeViewActions();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._availGridContainer.remove();
                this._availGridContainer = undefined;
                this._availFilterComponent = undefined;
                this._selectFilterComponent = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _onPlanDeviceSave() {
        this._disableViewActions();
        const selectedDeviceId = this._availableTargetsGrid.getSelectedRows()[0],
            selectedDevice =
                this._model._availableDevicesPagingFeed.getEntityById(selectedDeviceId),
            connectionInfo = selectedDevice.getConnectionInformation();

        this._model._planDetails._renderer._formsComponent.setPristineValue(connectionInfo);
        return this._model._planDetails._renderer._formsComponent._renderer.render().then(() => {
            const formVal = this._model._planDetails._renderer._formsComponent.getValue();
            this._model._planDetails.setConnectionInformation(formVal);
        });
    }

    _onPlanDeviceCancel() {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel? All changes will be lost.",
                title: "Cancel Confirmation",
                confirmDetails: {
                    text: "Yes",
                    type: "destructive",
                },
            },
            (this._onPlanDeviceCancelAction = this._onPlanDeviceCancelAction.bind(this))
        );
    }
    _onPlanDeviceCancelAction() {
        this._model.selectedIDs = this._prevSelectedIDs;
        this._model.availableTargetsPagingFeed.removeAllIds();
        this._model.selectedTargetsPagingFeed.removeAllIds();
        this._model.availableTargetsPagingFeed.addIds(this._prevSelectedIDs);
        this._model.selectedTargetsPagingFeed.addIds(this._prevSelectedIDs);
        this._model._plan.clearPendingRelationships(true);
        this._model.isDirty = false;
        // this.render();
        if (_.isNull(this._model._plan._pendingPatches)) {
            this._model._gameEditor.getTabCmpnt().setDirty(false);
        }
        this._toggleAction(true);
    }
    _checkDirtyGrid() {
        let target = Object.keys(this._targets);
        let prevData = this._prevSelectedIDs;
        this._model.selectedIDs = target;
        if (target.length !== prevData.length) {
            this._model.isDirty = true;
            this._toggleAction(false);
        } else if (
            _.difference(target, prevData).length > 0 ||
            _.difference(prevData, target).length > 0
        ) {
            this._model.isDirty = true;
            this._toggleAction(false);
        } else {
            this._model.isDirty = false;
            if (_.isNull(this._model._plan._pendingPatches)) {
                this._model._gameEditor.getTabCmpnt().setDirty(false);
            }
            this._toggleAction(true);
        }
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ManageDeviceViewRenderer;
